import { Card } from "@certn/cascadia-react";

import { LinkedCases } from "../components/LinkedCases";

interface Props {
  caseId: string | undefined;
}
export function LinkedCasesTab(props: Props) {
  return (
    <Card testID="linked-cases" type="large" responsive>
      <LinkedCases caseId={props.caseId} />
    </Card>
  );
}
